import {
  Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,
  Stack, Typography,
} from '@mui/material';

export default function BlofinLiveReconcileDialog({
  open, intent, busy, error, onClose, onConfirm,
}) {
  if (!intent) return null;

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Reconcilier le SL distant</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Alert severity="warning">
            Cette action ne cree aucun ordre MARKET et ne cree aucun SL. Elle lit la position et
            les TPSL distants, puis adopte le SL existant uniquement si son clientOrderId, son
            instrument, son sens, son prix et sa couverture correspondent exactement.
          </Alert>
          <Stack spacing={0.5}>
            <Typography variant="body2">Intention : {intent.intentId}</Typography>
            <Typography variant="body2">Instrument : {intent.instrumentId}</Typography>
            <Typography variant="body2">Statut : {intent.status}</Typography>
            <Typography variant="body2">Protection : {intent.slState}</Typography>
            <Typography variant="body2" color="error">
              Derniere erreur : {intent.lastError || 'SL_ACK_UNKNOWN'}
            </Typography>
          </Stack>
          <Alert severity="info">
            Si le SL est absent, ambigu, insuffisant ou non confirme par relecture, l&apos;intention
            restera UNPROTECTED. Aucun TP ne sera cree avant la confirmation distante du SL.
          </Alert>
          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Annuler</Button>
        <Button color="warning" variant="contained" disabled={busy} onClick={onConfirm}>
          {busy ? <CircularProgress size={18} /> : 'Reconcilier le SL'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
